module.exports = __webpack_public_path__ + "static/img/designBanner.8e83de59.png";